import { controls } from "../../controls";


const gold = {
  label: "gold Loan Details",
  pageLabel: "gold Loan Details",
  starting: true,
  url: "gold",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [

    ...controls.displayText({ label: "Receipt Number",star:true, width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Receipt Number",isRequired:true, name: "receipt_no", width: "col-sm-4" }),
    ...controls.displayText({ label: "Valuator",star:true, width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Valuator",isRequired:true, name: "valuator", width: "col-sm-4" }), 
{ 
  widths: "col-sm-12",
  subComponents:[
    ...controls.displayText({ label: "Code", width: "col-sm-2" }),
    ...controls.GoldCode({  width: "col-sm-2" }),
    ...controls.displayText({  width: "col-sm-2", label:"Name" }),
    ...controls.showData({name: "gold_code_display", data: "gold_code_display", width: "col-sm-2" }),
  
    ...controls.displayText({ label: "Description", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Description", name: "description", width: "col-sm-2" }),
    
    ...controls.displayText({ label: "Qty", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Oty", name: "qty", width: "col-sm-2" }),
    ...controls.displayText({ label: "Gross Wt in Grams", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Gross Wt in Grams", name: "gross_wt_grams", width: "col-sm-2" }),
    ...controls.displayText({ label: "Net Wt in Grams", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Net Wt in Grams", name: "net_wt_grams", width: "col-sm-2" }),
    ...controls.displayText({ label: "Rate By Grams", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Rate By Grams", name: "rate_by_grams", width: "col-sm-2" }),
    ...controls.displayText({ label: "Total Net Value", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Total Net Value", name: "total_net_value", width: "col-sm-2" }),
    ...controls.displayText({ label: "Return Date", width: "col-sm-2" }),
    ...controls.datePicker({name:"return_date",width:"col-sm-2"}),

    ...controls.button({
        label: "ADD", onclick: {
          action: "appendToHTMLTable",
          tableNameField: 'goldloan_table',
          requiredField: ["goldcode", "gold_code_display","description","qty","gross_wt_grams","net_wt_grams","rate_by_grams","total_net_value","return_date"]
        }, 
        width: "col-sm-1",
        style: { padding: 0 },
        Bcolor: "success"
      }),
      {
        inputType: "table",
        tableTitle: "",
        // convertedTo: "nominee_table",
        deletable: true,
        // editable: true,
        // addRows: true,
        tableHeaders: [
          { label: "Sr", type: "autoinc" },
          { label: "Code", field: "goldcode"},
          { label: "Name", field: "gold_code_display"},
          { label: "Description", field: "description"},
          { label: "Qty", field: "qty" },
          { label: "Gross Wt in Grams", field: "gross_wt_grams",displaytype: 'currency' },
          { label: "Net Wt in Grams", field: "net_wt_grams",displaytype: 'currency' },
          { label: "Rate By Grams", field: "rate_by_grams",displaytype: 'currency' },
          { label: "Total Net Value", field: "total_net_value",displaytype: 'currency' },
          { label: "Return Date", field: "return_date" ,displaytype: 'date'},
          // { label: "Given Date", field: "given_date" }
        ],
        widths: {
          parent: "col-sm-12",
          children: "col-sm-12"
        },
        name: "goldloan_table"
      },
    ]
  }
   
  ]
}

export default gold;